var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicatorDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37368 2.35341C9.72262 2.01566 10.2766 2.01566 10.6255 2.35341L15.1255 6.70896C15.4827 7.05466 15.492 7.62443 15.1463 7.98159C14.8006 8.33874 14.2308 8.34804 13.8737 8.00234L9.99961 4.25263L6.12554 8.00234C5.76839 8.34804 5.19861 8.33874 4.85292 7.98159C4.50723 7.62443 4.51652 7.05466 4.87368 6.70896L9.37368 2.35341ZM4.85292 12.0186C5.19861 11.6615 5.76839 11.6522 6.12554 11.9979L9.99961 15.7476L13.8737 11.9979C14.2308 11.6522 14.8006 11.6615 15.1463 12.0186C15.492 12.3758 15.4827 12.9455 15.1255 13.2912L10.6255 17.6468C10.2766 17.9845 9.72262 17.9845 9.37368 17.6468L4.87368 13.2912C4.51652 12.9455 4.50723 12.3758 4.85292 12.0186Z",
    fill: "#F26A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorDropdown);
export default __webpack_public_path__ + "static/media/indicator-dropdown.6cc4aa0db16639d2084ffe7860980482.svg";
export { ForwardRef as ReactComponent };